
    <span class="switch"
    [class.checked]="checked"
    [class.disabled]="disabled"
    [class.switch-large]="size === 'large'"
    [class.switch-medium]="size === 'medium'"
    [class.switch-small]="size === 'small'"
    [style.background-color]="getColor()"
    [style.border-color]="getColor('borderColor')"
    >
    <span class="switch-pane" *ngIf="checkedLabel || uncheckedLabel">
        <span class="switch-label-checked">{{ this.checkedLabel }}</span>
        <span class="switch-label-unchecked">{{ this.uncheckedLabel }}</span>
    </span>
    <small [style.background]="getColor('switchColor')">
    <ng-content></ng-content>
    </small>
    </span>
  